import type { GroupPanelViewState, SerializedDockview, SerializedGridObject } from 'dockview';
import { LEAF } from '../../../components/Layout/tokens';

export function visitLayoutLeaves(
  layout: SerializedDockview,
  visitor: (groupId: string, groupData: GroupPanelViewState, leaf: SerializedGridObject<GroupPanelViewState>) => void
) {
  visitNode(layout.grid.root);

  function visitNode(node: SerializedGridObject<GroupPanelViewState>) {
    if (Array.isArray(node.data)) {
      node.data.forEach(visitNode);
      return;
    }
    if (node.type === LEAF) {
      const groupData = node.data as GroupPanelViewState;
      const groupId = groupData.id;
      if (groupId != null) {
        visitor(groupId, groupData, node);
      }
    }
  }
}

export function getViewsByGroupId(layout: SerializedDockview): Map<string, string[]> {
  const viewsByGroupId = new Map<string, string[]>();
  visitLayoutLeaves(layout, (groupId, groupData) => {
    viewsByGroupId.set(groupId, [...(groupData.views ?? [])]);
  });
  return viewsByGroupId;
}

/** Maps each panel content type to the group it belongs to in the default layout. */
export function getHomeGroupByContentComponent(defaultLayout: SerializedDockview): Map<string, string> {
  const homeGroupByContentComponent = new Map<string, string>();
  visitLayoutLeaves(defaultLayout, (groupId, groupData) => {
    for (const viewId of groupData.views ?? []) {
      const contentComponent = defaultLayout.panels[viewId]?.contentComponent;
      if (contentComponent != null) {
        homeGroupByContentComponent.set(contentComponent, groupId);
      }
    }
  });
  return homeGroupByContentComponent;
}

export function getAllViewIdsInLayout(layout: SerializedDockview): Set<string> {
  const viewIds = new Set<string>();
  visitLayoutLeaves(layout, (_groupId, groupData) => {
    for (const viewId of groupData.views ?? []) {
      viewIds.add(viewId);
    }
  });
  return viewIds;
}
